import { render, staticRenderFns } from "./CreateHostPage.vue?vue&type=template&id=cfc0795a&scoped=true&"
import script from "./CreateHostPage.vue?vue&type=script&lang=js&"
export * from "./CreateHostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc0795a",
  null
  
)

export default component.exports